<template>
        <div id="modal-proj-price-set" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="container">
                        <div class="row mb-2">
                            <div class="col-6">公開単価設定</div>
                            <div class="col p-0">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" v-model="pub" class="custom-control-input" id="customSwitch1">
                                    <label class="custom-control-label" for="customSwitch1">{{this.setLabel}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6 pt-2">公開単価開始</div>
                            <div class="col p-0">
                                <select class="form-control" v-model="priceStart" :disabled="priceDisabled">
                                    <option value="0">-- 選択 --</option>
                                    <option v-for="(n,index) in 200" :key="index" :value="n">{{n}}万円</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pt-2">公開単価終了</div>
                            <div class="col p-0">
                                <select class="form-control" v-model="priceEnd" :disabled="priceDisabled">
                                    <option value="0">-- 選択--</option>
                                    <option v-for="(n,index) in 200" :key="index" :value="n">{{n}}万円</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" type="button" @click="projPricePub" :disabled="btnDisabled">
                        設定する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                pub: false,
                priceStart: '0',
                priceEnd: '0',
                id: ''
            }
        },
        watch: {
            getCmpProjPricePubStatus (status) {
                if (status == 0) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('reflectList', this.getCmpProjPricePubliced.data)
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            setLabel () {
                return this.pub ? '公開' : '非公開'
            },
            priceDisabled () {
                return !this.pub
            },
            btnDisabled () {
                return this.pub && this.priceEnd == '0' ? true : false
            },
            ...mapGetters(['getCmpProjPricePubStatus', 'getCmpProjPricePubliced'])
        },
        methods: {
            openThis (item) {
                this.resetThis()
                this.id = item.id
                this.priceStart = item.proj_price_pub_start
                this.priceEnd = item.proj_price_pub_end
                this.pub = this.priceEnd != '0' ? true : false
                $('#modal-proj-price-set').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-proj-price-set').modal('hide')
            },
            resetThis () {
                this.pub = true,
                this.priceStart = '60',
                this.priceEnd = '60',
                this.id = ''
            },
            projPricePub () {
                this.$store.dispatch('cmpProjPricePub', {
                    id: this.id,
                    pub: this.pub,
                    priceStart: this.pub ? this.priceStart : '0',
                    priceEnd: this.pub ? this.priceEnd : '0'
                })
            }
        }
    }
</script>

<style>

</style>
